module.exports = __webpack_public_path__ + "img/skating.be5030ca.webp";